import React from 'react';

export type Props = {
  alt?: string;
  height?: string;
  width?: string;
  objectFit?: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down';
  src?: string;
  style?: Record<string, string>;
};

function Image(props: Props) {
  return (
    <img
      alt={props.alt}
      src={props.src}
      height={props.height ?? '100%'}
      width={props.width ?? '100%'}
      style={{
        objectFit: props.objectFit ?? 'cover',
        height: props.height,
        width: props.width,
        ...props.style,
      }}
    />
  );
}

export default Image;
